import { gsap } from "gsap";

import { AbstractBitmapText } from "../../../../../abstracts/graphics/AbstractBitmapText";
import { AbstractSpine } from "../../../../../abstracts/graphics/AbstractSpine";
import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { AbstractScreen } from "../../../../../abstracts/modules/screens/AbstractScreen";
import {
    fadeAndStopSound,
    playNextBackgroundMusic,
    playSound,
    startAmbSounds,
    stopAmbSounds,
} from "../../../../../abstracts/utils/SoundUtils";
import { DDD } from "../../../../DDD";
import {
    DDDFontsNames,
    DDDSoundNames,
    DDDSpineNames,
} from "../../../../assetsLoader/DDDAssetsNames";

export class DDDFreespinIntroScreen extends AbstractScreen {
    protected backgroundSpine: AbstractSpine;
    protected fsLeftText: AbstractBitmapText;

    constructor(parentContainer: AbstractView, name: string = `DDDFreespinIntroScreen`) {
        super(name, parentContainer);
    }

    protected getSpineName(): string {
        return DDDSpineNames.FS_INTRO;
    }

    protected getTweenName(): string {
        return `deadspinintro`;
    }

    protected init(): void {
        super.init();

        this.addBackgroundImage();
        this.addContinueButton();
        this.addCustomText();
        this.addSpinsNameAndText();
    }

    protected addBackgroundImage(): void {
        this.backgroundSpine = new AbstractSpine(this.getSpineName());
        this.backgroundSpine.scale.set(0.5);
        this.backgroundSpine.name = `bgSpine`;

        this.addChild(this.backgroundSpine);
    }

    protected addSpinsNameAndText(): void {}

    protected addContinueButton(): void {
        this.continueButton.addClickCallback(() => this.continueButtonClickCallback());
        this.continueButton.pivot.set(this.continueButton.width / 2, 0);
        this.continueButton.position.set(0, 220);
        this.continueButton.enable(true);
    }

    protected continueButtonClickCallback(): void {
        this.onContinueBtnClick();
        this.selfRemoveFromParent();

        this.backgroundSpine?.reset();

        this.removeChild(this.continueButton);

        playSound({ name: DDDSoundNames.CONTINUE_BUTTON });
        playSound({ name: DDDSoundNames.FS_ON_CONTINUE });
        startAmbSounds();

        fadeAndStopSound({ name: this.getIntroLoopSoundName(), duration: 0.5, from: 1, to: 0 });
        if (!this.name.toLowerCase().includes(`outro`.toLowerCase())) {
            playNextBackgroundMusic();
        }
    }

    protected addCustomText(): void {
        this.fsLeftText = new AbstractBitmapText({
            text: `ways`,
            style: {
                fontName: DDDFontsNames.DEFAULT,
                fontSize: 14,
                letterSpacing: 20,
                tint: 0xc2beb4,
            },
        });
        this.fsLeftText.name = `fsLeftText`;
        this.fsLeftText.x = 0;
        this.fsLeftText.y = -205;
        this.fsLeftText.alpha = 0.9;

        this.addChild(this.fsLeftText);
    }

    public override getGsapAnimation(fsLeft: number = 0): gsap.core.Timeline {
        this.fsLeftText.updateValue(`${fsLeft}`);

        const tl = gsap.timeline({ autoRemoveChildren: true });

        const isFeatureBuyAndAutoplay =
            DDD.model.data.wasFeatureBuy && DDD.autoPlayPlugin.isAutoplayRound;

        const showScreenTween = gsap.fromTo(
            this,
            { alpha: 0 },
            {
                alpha: 1,
                duration: 0.3,
                onStart: () => {
                    if (!isFeatureBuyAndAutoplay) {
                        this.addChild(this.continueButton);
                    }

                    playSound({ name: this.getIntroStartSoundName() });
                    playSound({ name: this.getIntroLoopSoundName(), repeat: -1 });
                    stopAmbSounds();

                    this.backgroundSpine.getSpineTween(this.getTweenName());
                },
                onComplete: () => {
                    if (isFeatureBuyAndAutoplay) {
                        gsap.delayedCall(1.2, () => this.continueButtonClickCallback());
                    }
                },
            }
        );

        tl.add(showScreenTween);

        return tl;
    }

    protected getIntroStartSoundName(): string {
        return DDDSoundNames.FS_INTRO_START;
    }

    protected getIntroLoopSoundName(): string {
        return DDDSoundNames.FS_INTRO_LOOP;
    }
}
